import React from "react";
import { useParams } from "react-router-dom";
import { Row } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import AliceCarousel from "react-alice-carousel";

import useWindowDimensions from "../../utils/useWindowDimensions";
import useMapData from "../../utils/useMapData";

import "./Gallery.scss";

const handleDragStart = e => e.preventDefault();

const Gallery = React.forwardRef((props, ref) => {
  const { width } = useWindowDimensions();

  const { propertyId } = useParams();
  const resultList = useMapData(propertyId);

  const isWideScreen = width > 768;

  const extractImages = () => {
    let images = [];

    resultList.galleryImages?.map(item => {
      return images.push(
        <img
          key={item}
          width={"100%"}
          height={275}
          alt="gallery"
          src={item}
          onDragStart={handleDragStart}
          role="presentation"
        />
      );
    });

    return images;
  };

  const items = extractImages();

  return (
    <Row className="gallery_wrapper">
      <div id="horizontal_text">
        <h1 style={{ color: resultList.themeColor }}>Gallery</h1>
      </div>
      <AliceCarousel
        mouseTracking
        items={items}
        infinite
        autoPlay
        autoPlayInterval={1500}
        controlsStrategy="responsive"
        keyboardNavigation
        renderNextButton={() => {
          return <RightOutlined id="carousel_btn" />;
        }}
        renderPrevButton={() => {
          return <LeftOutlined id="carousel_btn" />;
        }}
        responsive={{
          0: {
            items:
              isWideScreen && resultList?.galleryImages?.length > 2 ? 3 : 1,
          },
        }}
      />
    </Row>
  );
});

export default Gallery;
